import script from "./CtaView.vue?vue&type=script&setup=true&lang=js"
export * from "./CtaView.vue?vue&type=script&setup=true&lang=js"

import "./CtaView.vue?vue&type=style&index=0&id=13e6aa9c&lang=css"

const __exports__ = script;

export default __exports__